import { render, staticRenderFns } from "./icon-compass.vue?vue&type=template&id=4881ddb7&"
import script from "./icon-compass.vue?vue&type=script&lang=js&"
export * from "./icon-compass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports